import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";
import * as moment from "moment";

@Injectable()
export class ReportReviewQueryService {
  public CREATE_REPORT_REVIEW: any;

  public GET_All_STORED_REPORTS_DATA: any;
  public GET_LAST_REVIEW_ID_DATA: any;
  public GET_All_REPORTS_DATA: any;

  public UPDATE_REPORT_REVIEW_DATA: any;
  public DELETE_REPORT_REVIEW_DATA: any;
  public ITEMS_FILTER_IN_SOLUTION: any;

  constructor(public apollo: Apollo) {
    //Create report review detail without categoryid,subcategory id
    this.CREATE_REPORT_REVIEW = gql`
      mutation CREATE_REPORT_SOLUTION_MUTATION_WITHOUT_ID_DATA(
        $input: CreateReportReviewDetailInput!
      ) {
        createReportReviewDetail(input: $input) {
          reportReviewDetail {
            id
            reviewId
          }
        }
      }
    `;

    this.GET_All_STORED_REPORTS_DATA = gql`
      query GetReturnSelectedId($Id: Int!) {
        allReportReviewDetails(
          condition: { orderId: $Id }
          orderBy: REVIEW_ID_ASC
        ) {
          edges {
            node {
              reviewId
              id
              insReportId
              categoryId
              subCategoryId
              categoryName
              subCategoryName
              description
              solution
              totalCost
              nodeId
              imagePath
              solCategory
              solSubCategory
              itemNumWc
              approve
              keywords
              hourRate
              laborHour
              materialCost
              costOption
              labourCost
              ni
              cpi
              cpf
              tf
              keyPrimCategory
              key1
              keyPhrase
              key2
              key3
              key4
              approveDatetime
            }
          }
        }
      }
    `;
    this.GET_LAST_REVIEW_ID_DATA = gql`
      {
        allReportReviewDetails(orderBy: REVIEW_ID_DESC, first: 1) {
          edges {
            node {
              reviewId
              id
              nodeId
            }
          }
        }
      }
    `;
    this.GET_All_REPORTS_DATA = gql`
      {
        allReportReviewDetails(orderBy: REVIEW_ID_DESC) {
          edges {
            node {
              orderId
            }
          }
        }
      }
    `;
    this.UPDATE_REPORT_REVIEW_DATA = gql`
      mutation myMutation($input: UpdateReportReviewDetailInput!) {
        updateReportReviewDetail(input: $input) {
          reportReviewDetail {
            description
            reviewId
            id
            solution
            modifiedAt
            imagePath
            solCategory
            solSubCategory
            approveDatetime
          }
        }
      }
    `;
    //Delete report review details
    this.DELETE_REPORT_REVIEW_DATA = gql`
      mutation DELETE_REPORT_SOLUTION_MUTATION(
        $input: DeleteReportReviewDetailByIdInput!
      ) {
        deleteReportReviewDetailById(input: $input) {
          deletedReportReviewDetailId
        }
      }
    `;

    this.ITEMS_FILTER_IN_SOLUTION = gql`
      query fliterItemsFromSolutions($Id: Int!, $items: [String!]) {
        allReportReviewDetails(
          filter: { categoryName: { in: $items }, orderId: { equalTo: $Id } }
        ) {
          nodes {
            reviewId
            categoryName
          }
        }
      }
    `;
  }
  FLITER_ITEM_FROM_SOLUTIONS(orderId, itemsArray) {
    return this.apollo.query({
      query: this.ITEMS_FILTER_IN_SOLUTION,
      variables: {
        Id: orderId,
        items: itemsArray,
      },
      fetchPolicy: "network-only",
    });
  }

  CREATE_REPORT_SOLUTION_MUTATION(
    orderId,
    lastReviewId,
    insReportId,
    matchQuery,
    allElement
  ) {
    return this.apollo.mutate({
      mutation: this.CREATE_REPORT_REVIEW,
      variables: {
        input: {
          reportReviewDetail: {
            orderId: Number.parseInt(orderId),
            reviewId: lastReviewId,
            insReportId: insReportId,
            categoryName: allElement.solType || "", //gven from 3rd input
            subCategoryName: allElement.catagoryType
              ? allElement.catagoryType
              : allElement.subCategoryName, //gven from 1st input
            description: allElement.description, //gven from 2nd input
            categoryId: matchQuery.categoryId,
            subCategoryId: matchQuery.subCategoryId,
            createdAt: new Date(),
            totalCost: Number.parseFloat(allElement.totalCost) || 0,
            solution: allElement.solution, //gven from 4th input
            imagePath: allElement.imageSrc,
            solCategory: allElement.categoryName, //allElement.solSheetName //gven from backend category
            solSubCategory: allElement.subCategoryName, //gven from backend subcategory
            approve: "no",
          },
        },
        fetchPolicy: "cache-first",
      },
    });
  }
  CREATE_REPORT_SOLUTION_MUTATION_WITHOUT_ID(
    orderId,
    lastReviewId,
    insReportId,
    categoryName,
    subCategoryName,
    allElement,
    keywords
  ) {
    var result = this.apollo.mutate({
      mutation: this.CREATE_REPORT_REVIEW,
      variables: {
        input: {
          reportReviewDetail: {
            orderId: Number.parseInt(orderId),
            reviewId: lastReviewId,
            insReportId: insReportId,
            categoryName: categoryName || "", //Array.isArray(splitCategoryName) ? splitCategoryName[0] : splitCategoryName
            description: allElement.description || "",
            createdAt: new Date(),
            totalCost: Number.parseFloat(allElement.totalCost) || 0,
            solution: allElement.solution || allElement.summary,
            itemNumWc: allElement.itemNumber || "",
            approve: "no",
            costOption: allElement.costOption,
            hourRate: Number.parseFloat(allElement.hourRate),
            laborHour: Number.parseInt(allElement.laborHour),
            labourCost: Number.parseFloat(allElement.labourCost) || 0,
            materialCost: Number.parseFloat(allElement.materialCost),
            keywords: allElement.searchKeyWords,
            ni: Number.parseInt(allElement.ni),
            cpi: Number.parseFloat(allElement.cpi),
            cpf: Number.parseFloat(allElement.cpf),
            tf: Number.parseInt(allElement.tf),
            keyPrimCategory: allElement.keyPrimCategory,
            key1: allElement.key1,
            keyPhrase: allElement.keyPhrase,
            key2: allElement.key2,
            key3: allElement.key3,
            key4: allElement.key4,

            subCategoryName: subCategoryName || "",
            imagePath: allElement.imageSrc || "",
            solCategory: allElement.categoryName || "", //allElement.solSheetName
            solSubCategory: allElement.subCategoryName || "",
          },
        },
        fetchPolicy: "cache-first",
      },
    });
    return result;
  }

  //2.get all details of order(category,sub catrogry )
  GET_All_STORED_REPORTS(orderId) {
    return this.apollo.query({
      query: this.GET_All_STORED_REPORTS_DATA,
      variables: {
        Id: Number.parseInt(orderId),
      },
      fetchPolicy: "network-only",
    });
  }

  //2.get all details (category,sub catrogry )
  GET_All_REPORTS() {
    return this.apollo.query({
      query: this.GET_All_REPORTS_DATA,
      fetchPolicy: "network-only",
    });
  }

  //Get last stored review data
  GET_LAST_REVIEW_ID() {
    return this.apollo.watchQuery({
      query: this.GET_LAST_REVIEW_ID_DATA,
      fetchPolicy: "network-only",
    });
  }
  UPDATE_REPORT_REVIEW(editForm, category) {
    //Maincategory name
    var mainCategoryName = editForm.get("categoryName").value
      ? editForm.get("categoryName").value
      : "";

    return this.apollo.mutate({
      mutation: this.UPDATE_REPORT_REVIEW_DATA,
      variables: {
        input: {
          reportReviewDetailPatch: {
            description: editForm.get("description").value,
            totalCost: Number.parseFloat(editForm.get("totalCost").value),
            modifiedAt: new Date(),
            categoryName: mainCategoryName,
            // "subCategoryName": mainCatgeory,
            categoryId: Number.parseInt(editForm.get("categoryId").value),
            subCategoryId: Number.parseInt(editForm.get("subCategoryId").value),
            solution: editForm.get("solution").value,
            // "imagePath": editForm.get('imagePath').value,
            // "solCategory": editForm.get('solCategory').value, //solSheetName
            // "solSubCategory": editForm.get('solSubCategory').value,
            approve: "no",
            keywords: editForm.get("keywords").value,
            costOption: editForm.get("costOption").value,
            hourRate: editForm.get("hourRate").value
              ? Number.parseFloat(editForm.get("hourRate").value)
              : 0.0,
            laborHour: editForm.get("laborHour").value
              ? Number.parseFloat(editForm.get("hourRate").value)
              : 0.0,
            materialCost: editForm.get("materialCost").value
              ? Number.parseFloat(editForm.get("materialCost").value)
              : 0,
            labourCost: editForm.get("labourCost").value
              ? Number.parseInt(editForm.get("labourCost").value)
              : 0,
            ni: editForm.get("ni").value
              ? Number.parseInt(editForm.get("ni").value)
              : 0,
            cpi: editForm.get("cpi").value
              ? Number.parseFloat(editForm.get("cpi").value)
              : 0.0,
            cpf: editForm.get("cpf").value
              ? Number.parseFloat(editForm.get("cpf").value)
              : 0.0,
            tf: editForm.get("tf").value
              ? Number.parseFloat(editForm.get("tf").value)
              : 0.0,
            keyPrimCategory: editForm.get("keyPrimCategory").value,
            key1: editForm.get("key1").value,
            keyPhrase: editForm.get("keyPhrase").value,
            key2: editForm.get("key2").value,
            key3: editForm.get("key3").value,
            key4: editForm.get("key4").value,
          },
          nodeId: category.reviewNodeId,
        },
      },
      fetchPolicy: "no-cache",
    });
  }

  UPDATE_APPROVE_REPORT_REVIEW(id, isApprove) {
    return this.apollo.mutate({
      mutation: this.UPDATE_REPORT_REVIEW_DATA,
      variables: {
        input: {
          reportReviewDetailPatch: {
            approve: isApprove,
            approveDatetime: "now()",
          },
          nodeId: id,
        },
      },
      fetchPolicy: "no-cache",
    });
  }

  UPDATE_REPORT_REVIEW_FOR_WC(nodeId, allObjects) {
    return this.apollo.mutate({
      mutation: this.UPDATE_REPORT_REVIEW_DATA,
      variables: {
        input: {
          reportReviewDetailPatch: {
            totalCost: Number.parseFloat(allObjects.totalCost),
            modifiedAt: new Date(),
            categoryName: allObjects.mainCategory,
            subCategoryName: allObjects.subCategory,
            solution: allObjects.summary,
            itemNumWc: allObjects.itemNumber,
          },
          nodeId: nodeId,
        },
      },
      fetchPolicy: "no-cache",
    });
  }

  // After drag row ,save items - spekwo
  UPDATE_REPORT_REVIEW_AFTER_DRAGGING(nodeId, data) {
    return this.apollo.mutate({
      mutation: this.UPDATE_REPORT_REVIEW_DATA,
      variables: {
        input: {
          reportReviewDetailPatch: {
            categoryName: data.categoryName,
            subCategoryName: data.subCategoryName,
            description: data.description,
            totalCost: Number.parseFloat(data.totalCost),
            solution: data.solution,
            imagePath: data.imagePath,
            solCategory: data.solCategory, // data.solCategory
            solSubCategory: data.solSubCategory,
            itemNumWc: data.itemNumWc,
            categoryId: data.categoryId,
            subCategoryId: data.subCategoryId,
            approve: data.approve,
            keywords: data.keywords,
            hourRate: Number.parseFloat(data.hourRate),
            laborHour: Number.parseInt(data.laborHour),
            labourCost: Number.parseFloat(data.labourCost),
            materialCost: Number.parseFloat(data.materialCost),
            costOption: data.costOption,
            ni: Number.parseInt(data.ni),
            cpi: Number.parseFloat(data.cpi),
            cpf: Number.parseFloat(data.cpf),
            tf: Number.parseInt(data.tf),
            keyPrimCategory: data.keyPrimCategory,
            key1: data.key1,
            keyPhrase: data.keyPhrase,
            key2: data.key2,
            key3: data.key3,
            key4: data.key4,
          },
          nodeId: nodeId,
        },
      },
      fetchPolicy: "no-cache",
    });
  }

  // After drag row ,save items - spekcall/spekwalk
  UPDATE_REPORT_REVIEW_AFTER_DRAGGING_WC(nodeId, data) {
    return this.apollo.mutate({
      mutation: this.UPDATE_REPORT_REVIEW_DATA,
      variables: {
        input: {
          reportReviewDetailPatch: {
            categoryName: data.mainCategory,
            subCategoryName: data.subCategory,
            description: data.description,
            totalCost: data.totalCost,
            solution: data.summary,
            imagePath: data.imagePath,
            solCategory: data.solCategory,
            solSubCategory: data.solSubCategory,
            itemNumWc: data.itemNumber,
            approve: data.approve,
          },
          nodeId: nodeId,
        },
      },
      fetchPolicy: "no-cache",
    });
  }

  DELETE_REPORT_REVIEW(category) {
    return this.apollo.mutate({
      mutation: this.DELETE_REPORT_REVIEW_DATA,
      variables: {
        input: {
          id: category.id,
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/reportReview.ts